<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img src="/img/avatars/default-avatar.png" class="img-avatar" alt="">
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>Account</strong>
      </b-dropdown-header>
      <!-- <b-dropdown-item>
        <i class="fa fa-user"/> Profile
      </b-dropdown-item> -->
      <!-- <b-dropdown-item>
        <i class="fa fa-wrench"/> Settings
      </b-dropdown-item> -->

      <!-- <b-dropdown-item>
        <i class="fa fa-shield"/> Lock Account
      </b-dropdown-item>-->
      <b-dropdown-item @click="logout()">
        <i class="fa fa-lock"/> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
import { mapActions } from 'vuex';
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 };
  },
  methods: {
    ...mapActions('auth', ['clearLogin']),
    logout() {
      this.clearLogin();
      this.$router.push('/login');
    }
  }
};
</script>
